import baseURL from "../common/axios";
class Commonservices {
  createStockWOTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockWOTransTM/Create", data);
  }

  updateStockWOTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockWOTransTM/Update", data);
  }
  GetSupplierDetailsByItemId(ItemId, Brand, ModelNumber, Size, UOM) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetSupplierDetailsByItemId?ItemId=" +
      ItemId +
      "&Brand=" +
      Brand +
      "&ModelNumber=" +
      ModelNumber +
      "&Size=" +
      Size +
      "&UOM=" +
      UOM
    );
  }
  GetStockWOTM(
    startDate,
    endDate,
    PageSize,
    PageNum,
    docType,
    columnName,
    columnValue,
    columnName1,
    columnValue1,
    columnName2,
    columnValue2,
    Flag,
    SearchOption,
    columnName3,
    columnValue3,
    Condition
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/List/StartDate/EndDate/PageNum/PageSize?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&DocType=" +
      docType +
      "&columnName=" +
      columnName +
      "&columnValue=" +
      columnValue +
      "&columnName1=" +
      columnName1 +
      "&columnValue1=" +
      columnValue1 +
      "&columnName2=" +
      columnName2 +
      "&columnValue2=" +
      columnValue2 +
      "&columnName3=" +
      columnName3 +
      "&columnValue3=" +
      columnValue3 +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      "&Condition=" +
      Condition +
      ""
    );
  }

  GetStockWOTMCustom(
    startDate,
    endDate,
    PageSize,
    PageNum,
    docType,
    columnName,
    columnValue,
    columnName1,
    columnValue1,
    columnName2,
    columnValue2,
    Flag,
    SearchOption,
    columnName3,
    columnValue3,
    Condition
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/ListStockWOTransTM/StartDate/EndDate/PageNum/PageSize?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&DocType=" +
      docType +
      "&columnName=" +
      columnName +
      "&columnValue=" +
      columnValue +
      "&columnName1=" +
      columnName1 +
      "&columnValue1=" +
      columnValue1 +
      "&columnName2=" +
      columnName2 +
      "&columnValue2=" +
      columnValue2 +
      "&columnName3=" +
      columnName3 +
      "&columnValue3=" +
      columnValue3 +
      "&Flag=" +
      Flag +
      "&SearchOption=" +
      SearchOption +
      "&Condition=" +
      Condition +
      ""
    );
  }

  // GetStockWOTM(
  //   startDate,
  //   endDate,
  //   PageSize,
  //   PageNum,
  //   docType,
  //   columnName,
  //   columnValue,
  //   columnName1,
  //   columnValue1
  // ) {
  //   return baseURL.httpMSInventoryUrl.get(
  //     "StockWOTransTM/List/StartDate/EndDate/PageNum/PageSize?startDate=" +
  //       startDate +
  //       "&endDate=" +
  //       endDate +
  //       "&pageSize=" +
  //       PageSize +
  //       "&pageNum=" +
  //       PageNum +
  //       "&DocType=" +
  //       docType +
  //       "&columnName=" +
  //       columnName +
  //       "&columnValue=" +
  //       columnValue +
  //       "&columnName1=" +
  //       columnName1 +
  //       "&columnValue1=" +
  //       columnValue1 +
  //       ""
  //   );
  // }

  ListPOByPIId(startDate, endDate, PageSize, PageNum, docType, RefId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/ListPOByPIId?startDate=" +
      startDate +
      "&endDate=" +
      endDate +
      "&pageSize=" +
      PageSize +
      "&pageNum=" +
      PageNum +
      "&DocType=" +
      docType +
      "&RefId=" +
      RefId +
      ""
    );
  }

  DeleteStockWOTM(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "StockWOTransTM/Delete?Id=" + data
    );
  }

  GetIdStockWOTM(data) {
    return baseURL.httpMSInventoryUrl.get("StockWOTransTM/Get?id=" + data);
  }

  createStockWODetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockWODetailsTD/Create", data);
  }

  updateStockWODetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockWODetailsTD/Update", data);
  }

  getStockWODetails(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("StockWODetailsTD/Get?id=" + data);
  }

  GetByStockWOTransByRefId(RefId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetByStockWOTransByRefId?RefId=" + RefId
    );
  }

  UpdateStatusStockWODetailsTD(PRDetailsarr) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWODetailsTD/StatusChange",
      PRDetailsarr
    );
  }

  GetByStockWOTransId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetByStockWOTransId?id=" + data + ""
    );
  }
  GetIssueDetailsByRequestId(RequestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetIssueDetailsByRequestId?RequestId=" + RequestId + ""
    );
  }
  GetPOAListByPoId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/POAListByPoId?POId=" + data
    );
  }
  ListGetByRefId(RefId, Type) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWODetailsTD/ListGetByRefId?RefId=" + RefId + "&DocType=" + Type
    );
  }

  GetStockWOTMTableList(docType, StoreId, type, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetListByDocType?DocType=" +
      docType +
      "&StoreId=" +
      StoreId +
      "&type=" +
      type +
      "&HospitalId=" +
      HospitalId
    );
  }

  FileListByStoreId(StoreId, BranchId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/FileListByStoreId?StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId
    );
  }

  GetUnitRateByPO(DocType, StoreId, SupplierId, ItemId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetUnitRateByPO?DocType=" +
      DocType +
      "&StoreId=" +
      StoreId +
      "&SupplierId=" +
      SupplierId +
      "&ItemId=" +
      ItemId
    );
  }

  GetStockOutTMTableList(docType, StoreId, type, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetListByDocType?DocType=" +
      docType +
      "&StoreId=" +
      StoreId +
      "&type=" +
      type +
      "&HospitalId=" +
      HospitalId
    );
  }

  GetRequestIDs(requestId, flag, status, DocType, StoreBrMapId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/ListStockWOTransTMByToStoreId?id=" +
      requestId +
      "&flag=" +
      flag +
      "&status=" +
      status +
      "&DocType=" +
      DocType +
      "" +
      "&StoreBrMapId=" +
      StoreBrMapId
    );
  }

  GetRequestedItems(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetRequestItems?id=" + requestId + ""
    );
  }

  GetItemsByRequstId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetItemsByRequstId?id=" + requestId + ""
    );
  }

  GetItemsByRequstIdCustom(requestId, HospitalId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetItemsByRequstIdCustom?id=" +
      requestId +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId
    );
  }
  GetReplacementItemsByItemId(
    ItemId,
    StoreId,
    ToStoreId,
    BranchId,
    ToStoreBranchId,
    HospitalId,
    UOM,
    Type
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetReplacementItemsByItemId?ItemId=" +
      ItemId +
      "&StoreId=" +
      StoreId +
      "&ToStoreId=" +
      ToStoreId +
      "&BranchId=" +
      BranchId +
      "&ToStoreBranchId=" +
      ToStoreBranchId +
      "&HospitalId=" +
      HospitalId +
      "&UOM=" +
      UOM +
      "&Type=" +
      Type
    );
  }

  GetPickListByRequestId(requestId, HospitalId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetPickListByRequestId?id=" +
      requestId +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId
    );
  }
  UpdatePickStatus(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdatePickStatus",
      data
    );
  }

  GetItemsByRequstIdForPIPR(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "Custom/GetItemsByRequstIdForPIPR?id=" + requestId + ""
    );
  }

  GetAutoRequestItemByRequestId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetAutoRequestItemByRequestId?id=" + requestId + ""
    );
  }

  GetFreqRequestItemByRequestId(requestId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetFreqRequestItemByRequestId?id=" + requestId + ""
    );
  }

  GetItemsByIssueIdDocType(IssueId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockOutMasterTM/GetByStockOutId?id=" + IssueId + ""
    );
  }

  GetPIList() {
    return baseURL.httpMSInventoryUrl.get("Custom/ListStockWOTransTMCustom");
  }

  GetPIItemList(PIId) {
    return baseURL.httpMSInventoryUrl.get("Custom/GetPIItems?id=" + PIId + "");
  }

  deleteStockWoDetails(data) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockWODetailsTD/Delete?Id=" + data
    );
  }

  deleteStockWoDetailsCustom(data, IsApproval) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockWODetailsTD/DeleteCustom?Id=" + data + "&IsApproval=" + IsApproval
    );
  }

  deleteStockOutDetails(data) {
    return baseURL.httpMSInventoryUrl.delete(
      "StockOutDetailsTD/Delete?Id=" + data
    );
  }

  StockWOOutStatusChanged(ObjCancelPO) {
    debugger;

    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/StockWOOutStatusChanged",
      ObjCancelPO
    );
  }

  UpdateCloseStatus(ObjClosed) {
    debugger;

    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdateCloseStatus",
      ObjClosed
    );
  }
  UpdateSetReOrderLevelItemByStoreId(Obj) {
    debugger;

    return baseURL.httpMSInventoryUrl.post(
      "ItemStoreMappingMAP/UpdateSetReOrderLevelItemByStoreId",
      Obj
    );
  }

  GetReOrderLevelList(StoreId, HospitalId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/GetReOrderLevelItemByStoreId?StoreId=" +
      StoreId +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId
    );
  }
  GetReOrderLevelListfromto(StoreId, fromDate, toDate, HospitalId, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/GetReOrderLevelItem?StoreId=" +
      StoreId +
      "&FromDate=" +
      fromDate +
      "&ToDate=" +
      toDate +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId
    );
  }
  getSetReOrderLevelItemByStoreId(StoreId, BranchId, HospitalId) {
    return baseURL.httpMSInventoryUrl.get(
      "ItemStoreMappingMAP/GetSetReOrderLevelItemByStoreId?StoreId=" +
      StoreId +
      "&HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId
    );
  }
  GetByStockWOTransByMultipleId(Id) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetByStockWOTransByMultipleId?Ids=" + Id
    );
  }

  GetAutoRequestIds(StoreId, Type, BranchId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetAutoRequestIds?StoreId=" +
      StoreId +
      "&Type=" +
      Type +
      "&BranchId=" +
      BranchId
    );
  }

  GetListByDocNo(DocNo, StoreId, DocType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetListByDocNo?DocNo=" +
      DocNo +
      "&StoreId=" +
      StoreId +
      "&DocType=" +
      DocType
    );
  }

  GetListBySupplierId(SupplierId, StoreId, DocType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetListBySupplierId?SupplierId=" +
      SupplierId +
      "&StoreId=" +
      StoreId +
      "&DocType=" +
      DocType
    );
  }

  GetPOBySupplierId(SupplierId, StoreId, DocType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetPOBySupplierId?SupplierId=" +
      SupplierId +
      "&StoreId=" +
      StoreId +
      "&DocType=" +
      DocType
    );
  }

  GetPoListBySupplierId(SupplierId, StoreBrMapId, DocType) {
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetPoListBySupplierId?SupplierId=" +
      SupplierId +
      "&StoreBrMapId=" +
      StoreBrMapId +
      "&DocType=" +
      DocType
    );
  }
  UpdateApprovalStatus(EntityTransactionId, IsApproved) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdateApprovalStatus?EntityTransactionId=" +
      EntityTransactionId +
      "&IsApproved=" +
      IsApproved
    );
  }

  ExportSendMail(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("Common/ExportSendMail", data);
  }

  GetStockWODetailsById(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetStockWODetailsById?id=" + data
    );
  }

  GetPOItemsByPOId(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetPOItemsByPOId?id=" + data
    );
  }

  GetPendingListCount(HospitalId, BranchId, StoreId, StoreBrMapId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetPendingListCount?HospitalId=" +
      HospitalId +
      "&BranchId=" +
      BranchId +
      "&StoreId=" +
      StoreId +
      "&StoreBrMapId=" +
      StoreBrMapId
    );
  }
  ExportSendMailPickList(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "Common/ExportSendMailPickList",
      data
    );
  }
  createStockWODraft(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("StockWOTransTM/CreateDraft", data);
  }

  DeleteList(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "StockWODetailsTD/DeleteList?Id=" + data
    );
  }

  DeletedReasonById(data) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWODetailsTD/DeletedReasonById",
      data
    );
  }

  GetConsigneeItemsFromStockOut(
    StoreId,
    BranchId,
    HospitalId,
    FromDate,
    ToDate,
    SupplierId,
    BrandId,
    ModelNumberId,
    SizeId
  ) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "StockWOTransTM/GetConsigneeItemsFromStockOut?StoreId=" +
      StoreId +
      "&BranchId=" +
      BranchId +
      "&HospitalId=" +
      HospitalId +
      "&FromDate=" +
      FromDate +
      "&ToDate=" +
      ToDate +
      "&SupplierId=" +
      SupplierId +
      "&BrandId=" +
      BrandId +
      "&ModelNumberId=" +
      ModelNumberId +
      "&SizeId=" +
      SizeId
    );
  }

  UpdateIsConvertedRequest(RequestIds) {
    debugger;
    return baseURL.httpMSInventoryUrl.post(
      "StockWOTransTM/UpdateIsConvertedRequest?RequestIds=" + RequestIds + ""
    );
  }
}
export default new Commonservices();
